export const WIDGET_CHAT_VIEW_KEY = 'widgetChatView';
export const WIDGET_CONVERSATION_STARTED_KEY = 'widgetConversationStarted';

const IMAGE_EXTENSION = /\.(gif|png|jpe?g|webp|svg|avif)$/i;

export function isImageMediaUrl(url) {
  if (!url || typeof url !== 'string') return false;
  const path = url.trim().split('?')[0].split('#')[0];
  return IMAGE_EXTENSION.test(path);
}

export function renderWelcomeHtml(html) {
  if (!html || typeof html !== 'string') return '';
  return html
    .replace(/<script\b[^>]*>[\s\S]*?<\/script>/gi, '')
    .replace(/<iframe\b[^>]*>[\s\S]*?<\/iframe>/gi, '')
    .replace(/\son\w+\s*=\s*(['"])[\s\S]*?\1/gi, '')
    .replace(/\son\w+\s*=\s*[^\s>]+/gi, '')
    .replace(/javascript:/gi, '');
}

export function hasWelcomeContent(intermediate) {
  if (!intermediate || typeof intermediate !== 'object') return false;
  const mediaUrl = typeof intermediate.mediaUrl === 'string' ? intermediate.mediaUrl.trim() : '';
  const htmlText = typeof intermediate.html === 'string'
    ? intermediate.html.replace(/<[^>]*>/g, ' ').replace(/&nbsp;/g, ' ').trim()
    : '';
  return Boolean(mediaUrl || htmlText);
}

export function isWelcomeStepActive(customization) {
  if (!customization || customization.onPageLoadChatState === 'closed') return false;
  const intermediate = customization.intermediate;
  if (!intermediate || typeof intermediate !== 'object') return false;
  if (intermediate.forceOff === true) return false;
  if (intermediate.enabled === true) return true;
  return hasWelcomeContent(intermediate);
}

export function getIntermediateConfig(customization) {
  const source = customization && typeof customization === 'object' ? customization : {};
  const intermediate = source.intermediate && typeof source.intermediate === 'object' ? source.intermediate : {};
  const width = Number(intermediate.width) || Number(source.chatWidth) || 400;
  const height = Number(intermediate.height) || Number(source.chatHeight) || 600;
  const buttonTitle = typeof intermediate.buttonTitle === 'string' && intermediate.buttonTitle.trim()
    ? intermediate.buttonTitle.trim()
    : 'Start Conversation';

  return {
    enabled: intermediate.enabled === true,
    width,
    height,
    mediaUrl: typeof intermediate.mediaUrl === 'string' ? intermediate.mediaUrl.trim() : '',
    html: typeof intermediate.html === 'string' ? intermediate.html : '',
    buttonTitle,
  };
}
